export enum CardDisplay {
  DEFAULT = 0,
  HIDDEN = 1,
  TEXT = 2,
  ARMY = 3,
  ARMY_EDIT = 4,
  TEAM_ARMY = 5,
  DRAW_DEFAULT = 6,
  DRAW = 7,
  DRAW_RESPONSE = 8,
  MATCH = 9,
  TABLE = 10,
}
